<p-select
  [options]="stateOptions"
  [(ngModel)]="selectedValue"
  (onChange)="onStateChange($event)"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [styleClass]="styleClass"
  [filter]="true"
  filterPlaceholder="Search states"
  [showClear]="!required"
  [class.p-invalid]="required && !selectedValue"
  optionLabel="label"
  optionValue="value"
  [appendTo]="appendTo"
/>
